import React from 'react'
import './style.css'

import DownloadButtons from '../download-icons'

export default function DownloadBanner({ hed, className }) {
  return (
    <div className={`download-banner flex flex-center ${className}`}>
      <h3 className="download-banner__hed">Try the Kinzoo app today!</h3>
      <DownloadButtons />
    </div>
  )
}
